import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const HRM_068 = ({ pdfExportComponent, data, company,company2 }) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`เอกสารยืนยันการตรวจสอบสมุดบัญชีธนาคารเพื่อรับเงินเดือนหรือค่าจ้างของพนักงาน - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="formId"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "125px",
                  right: "65px",
                  border: "1px",
                  borderStyle: "solid",
                  padding: "8px",
                  paddingBottom: "0px",
                  paddingTop: "5px",
                  width: "80px",
                  fontSize: "20px",
                  letterSpacing: 0.14,
                }}
              >
                <b className="docs-font-bold">HRM-068</b>
              </div>
              <div
                id="header"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "123px",
                  right: "47px",
                  fontSize: "20px",
                  width: "705px",
                  // fontFamily: "angsaBold",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <b className="docs-font-bold">
                  เอกสารยืนยันการตรวจสอบสมุดบัญชีธนาคาร
                  <br />
                  เพื่อรับเงินเดือนหรือค่าจ้างของพนักงาน
                </b>
              </div>

              <div
                id="date"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "200px",
                  right: "74px",
                  fontSize: "20px",
                  // fontFamily: "angsaLight",
                  width: "310px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                  // backgroundColor: "red"
                }}
              >
                ทำที่ บริษัท {company.name_th}
                <br />
                วันที่..................เดือน.................................พ.ศ...................
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "254px",
                  right: "75px",
                  fontSize: "20px",
                  // fontFamily: "angsaLight",
                  width: "650px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                }}
              >
                เรื่อง ยืนยันเลขที่บัญชีรับค่าจ้าง
                <br />
                เรียน ฝ่ายทรัพยากรบุคคล
                <br />
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;โดยหนังสือฉบับนี้
                ข้าพเจ้า(นาย/นาง/นางสาว)
                ...........................................................................................
                ตำแหน่ง
                ............................................................................................................................
                รหัสพนักงาน .........................
                ขอเรียนให้บริษัทฯ ทราบว่า ข้าพเจ้าได้
                ดำเนินการตรวจสอบรายละเอียดของบัญชีธนาคารพาณิชย์ที่ข้าพเจ้าประสงค์ให้บริษัทฯโอนเงินค่าจ้าง
                เงินค่าตอบแทน อื่นๆให้กับข้าพเจ้าแล้ว <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;ขอยืนยันว่า บัญชี ธนาคาร
                ...........................................................................................
                จำกัด (มหาชน) สาขา
                ................................................... เลขที่บัญชี
                .............................................. ชื่อบัญชี
                ...................................................
                เป็นบัญชีของข้าพเจ้า ซึ่งบริษัทฯ
                สามารถโอนเงินค่าจ้างหรือค่าตอบแทนอื่นๆเข้าบัญชีธนาคารของข้าพเจ้าที่ได้แจ้งไว้
                ตามเอกสาร ที่ข้าพเจ้าได้ส่งให้กับบริษัทฯ ณ
                วันที่.....................................................
                <br />
                <br />
                <b className="docs-font-bold">
                  &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;หากมีกรณีใดๆที่บริษัทฯไม่สามารถโอนเงินค่าจ้างหรือค่าตอบแทนให้กับข้าพเจ้าโดยวิธีโอนเงินเข้าบัญชีธนาคารดังกล่าวข้างต้นอันมีสาเหตุเนื่องจากบัญชีธนาคารที่ข้าพเจ้าแจ้งได้ปิดบัญชีแล้วหรือเพราะสาเหตุอื่นใด
                  ข้าพเจ้า
                  ตกลงยอมรับโดยไม่มีข้อโต้แย้งและสละสิทธิในการเรียกร้องใดๆ
                  ต่อกรณีที่บริษัทฯจะชำระเงินค่าจ้างหรือค่าตอบแทนในงวดการชำระเงินถัดไป
                  ทั้งนี้จนกว่าข้าพเจ้าจะแจ้งเลขที่บัญชีใหม่ของข้าพเจ้าให้กับบริษัทฯทราบตามระเบียบและวิธีการที่บริษัทฯกำหนด
                </b>
                <br />
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;เอกสารฉบับนี้ข้าพเจ้าได้อ่านข้อความโดยตลอดแล้วเห็นว่าถูกต้องตรงตามเจตนารมณ์ของข้าพเจ้าทุกประการ
                จึงลงลายมือชื่อไว้เป็นสำคัญ ณ วันและสถานที่ซึ่งระบุข้างต้น
                <br />
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.............................................................(พนักงาน)
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(
                ............................................................ )
              </div>
            </div>
            <div id="var" className="var">
            {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "298px",
                  fontSize: "20px",
                  width: "62px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_day}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "159px",
                  fontSize: "20px",
                  width: "112px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_month}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "75px",
                  fontSize: "20px",
                  width: "64px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_year}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "332px",
                  right: "75px",
                  fontSize: "20px",
                  width: "310px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "359px",
                  right: data?.detail_position?.length >= 49 ? "280px" : "369px",
                  fontSize: "20px",
                  width: "250px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.detail_position}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "359px",
                  right: "64px",
                  fontSize: "20px",
                  width: "115px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.personal_info_id}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "440px",
                  right: "175px",
                  fontSize: "20px",
                  width: "291px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.BankName}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "466px",
                  right: "520px",
                  fontSize: "20px",
                  width: "176px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.BankBranch}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "466px",
                  right: "297px",
                  fontSize: "20px",
                  width: "156px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.BookNo}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "466px",
                  right: "74px",
                  fontSize: "20px",
                  width: "173px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.BookName}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "494px",
                  right: "309px",
                  fontSize: "20px",
                  width: "179px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.submit_date}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "873px",
                  right: "250px",
                  fontSize: "20px",
                  width: "202px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

HRM_068.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default HRM_068;
